import React, { useEffect, useState } from 'react';

//import Scss
import "./assets/scss/themes.scss";

//imoprt Route
import Route from './Routes';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import fakeBackend from "./helpers/AuthType/fakeBackend";
import { useDispatch } from 'react-redux';
import { userLogin } from './Redux/auth/authSlice';

// Activating fake backend
fakeBackend();

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

const App = () => {
  const [mount, setMount] = useState(false);

  useEffect(() => { setMount(true) }, []);

  const dispatch = useDispatch()

  useEffect(() => {
    if (mount) {

      const token = localStorage.getItem('knighthuntToken');
      const userData = JSON.parse(localStorage.getItem('knighthuntUserInfo'));

      dispatch(
        userLogin({
          acessToken: token,
          user: userData,
        })
      );
    }
  }, [mount])


  return (
    <React.Fragment>
      <Route />
      <ToastContainer autoClose={3000} />

    </React.Fragment>
  );
}

export default App;
